import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage } from "i18n";

// Selettore di lingua (Italiano / English): la scelta resta salvata nel browser.
export default function LanguageSwitch({ className = "" }) {
  const { i18n } = useTranslation();
  return (
    <span className={`lang-switch ${className}`} role="group" aria-label="Language">
      {LANGUAGES.map(([code]) => (
        <button
          key={code}
          type="button"
          className={`lang-btn ${i18n.language === code ? "on" : ""}`}
          onClick={() => setLanguage(code)}
          aria-pressed={i18n.language === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </span>
  );
}
